import { actionTypes } from '../../../types';

// Action creator for generating request
export const downloadContentForManualUpload = (payload, callback) => ({
    type: actionTypes.DOWNLOAD_CONTENT_FOR_MANUAL_UPLOAD_REQUEST,
    payload,
    callback
});

// Action creator for successful generation
export const downloadContentForManualUploadSuccess = (payload) => ({
    type: actionTypes.DOWNLOAD_CONTENT_FOR_MANUAL_UPLOAD_SUCCESS,
    payload,
});

// Action creator for failed generation
export const downloadContentForManualUploadFailure = (payload) => ({
    type: actionTypes.DOWNLOAD_CONTENT_FOR_MANUAL_UPLOAD_FAILURE,
    payload,
});

// Action creator for resetting generation status
export const downloadContentForManualUploadReset = () => ({
    type: actionTypes.DOWNLOAD_CONTENT_FOR_MANUAL_UPLOAD_RESET,
});

// Action creator for resetting all generation reducer
export const downloadContentForManualUploadResetAll = () => ({
    type: actionTypes.DOWNLOAD_CONTENT_FOR_MANUAL_UPLOAD_RESET_ALL,
});
